import { Box, Typography } from "@mui/material";

type Props = {
  currentBlock: any;
};

const TitleField = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;

  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography
        variant="h2"
        sx={{
          fontWeight: "regular",
          color: "text.primary",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
export default TitleField;
